/* global modUtils modForm */
/**
 * Validate Zip Code
 * No dependency on mod-form
 * @param {String} zip - zip code to validate
 * @param {Function} callback - callback function after server response
 */
export function isZipCodeValid(zip, callback) {
	const apiDomain = `https://${modUtils.getEnv() === 'production' ? 'hs.leadpost.net/' : 'hsleadpost1.quinstage.com/'}`;
	const request = new XMLHttpRequest();
	let response = {};
	request.open('GET', `${apiDomain}api/PostalCordinateInfo/${zip}/get`);
	request.send();
	request.addEventListener('load', function() {
		if (this.response) {
			response = { ...response, ...JSON.parse(this.response) };
			if (this.readyState === 4 && this.status === 200) {
				response.success = true;
				response.data = JSON.parse(this.response);
				response.data.zip = zip;
				modForm.opts.zipData = {
					city: response.data.city,
					state: response.data.state,
					country: response.data.country
				};

				if ('function' === typeof callback) {
					callback(response);
				}
			} else {
				if ('function' === typeof callback) {
					if (response.status === 400) {
						callback({
							error: true,
							message: response.error_message
						});
					} else {
						callback({});
					}
				}
			}
		}
	});
	request.addEventListener('error', function() {
		console.error('Something went wrong');
	});
}
